export default {
  RADIO: 'Surveys::Question::Radio',
  TEXT: 'Surveys::Question::Text',
};
